import { useState, useCallback } from 'react';
import { Copy, Check } from 'lucide-react';

interface CopyableIdProps {
  label: string;
  value: string;
}

export function CopyableId({ label, value }: CopyableIdProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    void navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }, [value]);

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/50 px-2.5 py-1 text-xs transition-colors hover:bg-muted"
      title={`Copiar ${label}`}
    >
      <span className="text-muted-foreground">{label}:</span>
      <span className="font-mono font-medium text-foreground">{value}</span>
      {copied ? (
        <Check size={12} className="text-green-600" />
      ) : (
        <Copy size={12} className="text-muted-foreground" />
      )}
    </button>
  );
}
